import api from "./api";

export const loadPage = (slug) => {
  return api.get(`/admin/pages/${slug}`);
};

export const savePage = (slug, data) => {
  return api.put(`/admin/pages/${slug}`, data);
};

export const loadPublicPage = (slug) => {
  return api.get(`/pages/${slug}`);
};
